import { combineReducers } from 'redux';
import * as types from '../types';
import * as authTypes from '@redux/types/auth';

const sessionId = (state: string | null = null, action: any) => {
  switch (action.type) {
    case authTypes.AUTHENTICATION_IDENTITY_CLEARED:
      return null;
    case types.ACTIVITY_SESSION_CREATE_COMPLETED:
      return action.payload.sessionId;
    case types.ACTIVITY_SESSION_CLOSE_COMPLETED:
      return null;
    default:
      return state;
  }
};

const buffer = (state: types.ActivityLogEntry[] = [], action: any) => {
  switch (action.type) {
    case types.ACTIVITY_LOG_ADDED:
      return [...state, action.payload];
    case types.ACTIVITY_LOG_FLUSH_COMPLETED:
      // Clears buffer after a successful flush (periodic or on logout)
      return [];
    default:
      return state;
  }
};

const isCreatingSession = (state = false, action: any) => {
  switch (action.type) {
    case types.ACTIVITY_SESSION_CREATE_STARTED:
      return true;
    case types.ACTIVITY_SESSION_CREATE_COMPLETED:
    case types.ACTIVITY_SESSION_CREATE_FAILED:
      return false;
    default:
      return state;
  }
};

const isFlushing = (state = false, action: any) => {
  switch (action.type) {
    case types.ACTIVITY_LOG_FLUSH_STARTED:
      return true;
    case types.ACTIVITY_LOG_FLUSH_COMPLETED:
    case types.ACTIVITY_LOG_FLUSH_FAILED:
      return false;
    default:
      return state;
  }
};

const logs = (state: types.ActivityLogRecord[] = [], action: any) => {
  switch (action.type) {
    case authTypes.AUTHENTICATION_IDENTITY_CLEARED:
      return [];
    case types.ACTIVITY_LOGS_FETCH_COMPLETED:
      return action.payload.logs;
    default:
      return state;
  }
};

const isFetchingLogs = (state = false, action: any) => {
  switch (action.type) {
    case types.ACTIVITY_LOGS_FETCH_STARTED:
      return true;
    case types.ACTIVITY_LOGS_FETCH_COMPLETED:
    case types.ACTIVITY_LOGS_FETCH_FAILED:
      return false;
    default:
      return state;
  }
};

const activityLog = combineReducers({
  sessionId,
  buffer,
  isCreatingSession,
  isFlushing,
  logs,
  isFetchingLogs
});

export default activityLog;

// Selectors
export const getOwnState = (state: any) => state.activityLog;
export const getSessionId = (state: any) => getOwnState(state)?.sessionId;
export const getBuffer = (state: any) => getOwnState(state)?.buffer ?? [];
export const getIsFlushing = (state: any) => getOwnState(state)?.isFlushing;
export const getActivityLogs = (state: any) => getOwnState(state)?.logs ?? [];
export const getIsFetchingLogs = (state: any) => getOwnState(state)?.isFetchingLogs;
